/* eslint-disable prettier/prettier */
//import { computed } from "vue"
import { useStore } from "vuex"

const registerVisit = () =>{
    const store = useStore()
    const getSectionPpl =  async (id_recinto) => {
        const resp = await store.dispatch("visits/getSection",id_recinto)
         return resp
    }
    const getDataVisit = async (data) => {
         const resp = await store.dispatch("visits/getDataVisit",data)
         return resp
    }
    const valueToSearch = async (data) => {
        const resp = await store.dispatch("visits/valueToSearch",data)
        return resp
    }
    const valueToSearchVisit = async (data) => {
        const resp = await store.dispatch("visits/valueToSearchVisit",data)
        return resp
    }
    const register = async (data) => {
        const resp = await store.dispatch("visits/register",data)
        return resp
    }
    const visitsList = async (data) =>{
        const resp = await store.dispatch("visits/visitsList",data)
        return resp
    }
    const visitDetails = async (data) =>{
        const resp = await store.dispatch("visits/visitDetails",data)
        return resp
    }
    const CheckOutVisit = async (value) =>{
        const resp = await store.dispatch("visits/CheckOutVisit", value)
        return resp
    }
    const saveImage = async (value) =>{
        const resp = await store.dispatch("visits/saveImage", value)
        return resp
    }
    const seeImagesfromBack = async (id_img_visita) => {
        const resp = await store.dispatch("visits/seeImagesfromBack", id_img_visita)
        return resp
    }
    const deleteImageFromBack = async (id_img_visita) => {
        const resp = await store.dispatch("visits/deleteImageFromBack", id_img_visita)
        return resp
    }
    const checkRestriction = async (data) => {
        const resp = await store.dispatch("visits/checkRestriction", data)
        return resp
    }
    const normativeList = async () => {
        const resp = await store.dispatch("visits/normativeList")
        return resp
    }
    const registerRestriction = async (data) => {
        const resp = await store.dispatch("visits/registerRestriction",data)
        return resp
    }
    const restrictionsList = async (data) =>{
        const resp = await store.dispatch("visits/restrictionsList",data)
        return resp
    }
    const uploadFile = async(data)=>{
        const resp = await store.dispatch("visits/uploadFile", data)
        return resp
    }
    const uploadFileLiftRestriction = async(data)=>{
        const resp = await store.dispatch("visits/uploadFileLiftRestriction", data)
        return resp
    }
    const deleteFile = async(id)=>{
        const resp = await store.dispatch("visits/deleteFile", id)
        return resp
    }
    const deleteFileLiftRestriction = async(id)=>{
        const resp = await store.dispatch("visits/deleteFileLiftRestriction", id)
        return resp
    }
    const viewFile = async (data)=> {
        const resp = await store.dispatch("visits/viewFile", data)
        return resp
    }
    const viewFileLiftRestriction = async (data)=> {
        const resp = await store.dispatch("visits/viewFileLiftRestriction", data)
        return resp
    }
    const liftRestriction = async (data)=> {
        const resp = await store.dispatch("visits/liftRestriction", data)
        return resp
    }
    const registerLiftRestriction = async (data)=> {
        const resp = await store.dispatch("visits/registerLiftRestriction", data)
        return resp
    }
    const infoRestriction = async (data) => {
        const resp = await store.dispatch("visits/infoRestriction", data)
        return resp
    }
    const updateRestriction = async(data) => {
        const resp = await store.dispatch("visits/updateRestriction", data)
        return resp
    }
    const deleteRestriction = async(data) => {
        const resp = await store.dispatch("visits/deleteRestriction", data)
        return resp
    }
    const verifyRestriction = async(data) => {
        const resp = await store.dispatch("visits/verifyRestriction", data)
        return resp
    }
    const registerOnlyVisit = async(data) => {
        const resp = await store.dispatch("visits/registerOnlyVisit", data)
        return resp
    }
    return{
        getSectionPpl,
        getDataVisit,
        valueToSearch,
        valueToSearchVisit,
        register,
        visitsList,
        visitDetails,
        CheckOutVisit,
        saveImage,
        seeImagesfromBack,
        deleteImageFromBack,
        checkRestriction,
        normativeList,
        registerRestriction,
        restrictionsList,
        uploadFile,
        uploadFileLiftRestriction,
        viewFile,
        viewFileLiftRestriction,
        deleteFile,
        deleteFileLiftRestriction,
        liftRestriction,
        registerLiftRestriction,
        infoRestriction,
        updateRestriction,
        deleteRestriction,
        verifyRestriction,
        registerOnlyVisit
    }
    
};

export default registerVisit